import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {RootState} from '/redux/reducer';

export const volumePerformanceReport = (state: RootState) =>
  state.volumePerformanceReport;

export const isListLoading = createSelector(
  volumePerformanceReport,
  get('isListLoading'),
);

export const isFetchingNextPage = createSelector(
  volumePerformanceReport,
  get('isFetchingNextPage'),
);

export const isEndReached = createSelector(
  volumePerformanceReport,
  get('isEndReached'),
);

export const getVolumePerformanceData = createSelector(
  volumePerformanceReport,
  get('data'),
);

export const getResultsCount = createSelector(
  volumePerformanceReport,
  get('resultsCount'),
);

export const getVolumePerformanceFilters = createSelector(
  volumePerformanceReport,
  get('filters'),
);

export const getVolumePerformanceSort = createSelector(
  volumePerformanceReport,
  get('sort'),
);
